import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation,useHistory } from 'react-router-dom';
import httpClient,{getBaseURL} from 'utility/httpClient.util';
import BackgroundError from './unauthorized.png';

const Unauthorized = () => {
    const location = useLocation();
    const history = useHistory();
    const reload = async ()=>{
        // Navigate to the root page with a unique query string to bypass cache           
        const queryParams = new URLSearchParams(location.search);        
        let rd = queryParams.get('rd') || window.location.origin;
            
        //debugger
        if (rd.includes('#/maintenance/')) {
            // rd contains a hash URL
            rd = window.location.origin;
        } else {
        }

                // Decode the rd parameter
        const decodedRd = decodeURIComponent(rd);

        // Check if the rd parameter was already encoded
        const isEncoded = rd !== decodedRd;

        if (isEncoded) {
            window.location.href = `${getBaseURL()}/oauth2/start?rd=${rd}`;
        }else{
            window.location.href = `${getBaseURL()}/oauth2/start?rd=${encodeURIComponent(rd)}`;
        }
    }

    useEffect(()=>{
        hideSplash()
    },[])

    const hideSplash = ()=>{
        const element = document.getElementById('public-splash-screen');
                if(element)
                    element.style.display = 'none';
    }

    return (
        <React.Fragment>
            <div className="auth-wrapper maintenance">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <div>
                                <img src={BackgroundError} alt="Error - 401" style={{width:'100%'}}/>
                            </div>
                            <div className="text-center">
                                <h5 className="my-4">Unauthorized Access!</h5>
                                <a onClick={()=>history.push('/')} className="btn btn-danger mb-4" ><i className="feather icon-refresh-ccw mr-2"/>Click Reload</a>
                                {/* <a onClick={()=>history.push('/')} className="btn btn-danger mb-4"><i className="feather icon-refresh-ccw mr-2"/>Back to Home</a> */}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Unauthorized;